<template>
  <div>
    <FloatingVideoPlayer
      style="position:absolute"
      video-source="img/TransPlus3PLAD.mp4"
      title="Your 3PL Partner"
      thumbnail-url="img/ad_video_thumbnail.jpg"
      @close="handleClose"
    />
    

    <div
      class="page-header"
      style="text-align:center;height:100vh;"
    >
      <div style="height:32px; background:#003366;line-height: 32px;">
        <a href="/contactuswarehousinganddistribution">Give us a call to chat with our team about how we can help you</a>
      </div>
      <div style="height:32px; background:whitesmoke; color: #003366;">
        <ul id="menu">
          <li><i class="far fa-star" /> 32 Years of Business</li>        
          <li><i class="far fa-smile" /> Thousands of Happy Clients</li>
          <li>
            <img
              slot="image"
              :src="imgAIB2"
              height="32px"
            >
            <img
              slot="image"
              :src="imgHACCP"
              height="32px"
            >
            <!--<span class="hide">AIB & HACCP Certified</span>-->
          </li>
        </ul>
      </div>
         
      <parallax
        class="page-header-image"  
        style="background-image: url('img/tp_ad01.jpg')"             
      />
      
      <div class="header">
        <div style="text-align:center;">
          <img
            id="tplogo"
            src="img/transplus.png"
            alt=""
            class="adlogo"
          >
        </div>

        <!--<h1 class="title">Warehousing, Distribution & 3PL <br> in Montreal & Toronto</h1>           -->
        <h1 class="title">
          3PL Warehousing & Logisitcs <br> in Montreal & Toronto
        </h1>         
        <div class="header-content">
          <h2>Thousands of satisfied customers and <br> over three decades of experience. </h2>     
                
          <a
            href="/contactuswarehousinganddistribution"
            class="btnBlue"
          > CONTACT US</a>                      
          <a
            v-if="isMobile()"
            href="tel:416-938-1293"
            class="btnWhite"
          > CALL US</a>  
          <a
            v-if="!isMobile()"
            href="tel:416-938-1293"
            class="btnWhite"
          >CALL 416-938-1293</a>  
                    
          <h5 style="padding-top:24px">
            * space size: Minimum of 5K sq/ft storage required
          </h5>                    
        </div>
      </div>

      <!--
      <video autoplay muted loop id="myVideo">
        <source src="img/TorontoTimelapse.mp4" type="video/mp4" />
      </video>      
      -->
    </div>      
    

    <!-- --><hr class="tpgreen">
    
    <div class="section">
      <div class="container col-md-6">        
        <div
          class="row"
          style="vertical-align: text-top;"
        >
          <div
            class="col-lg-6 col-sm-12 text-center"
            style="margin: auto;"
          >                        
            <h3 class="title">
              Over half a <span style="color:dodgerblue">
                million square feet </span> of ambient temperature warehousing and distribution space in between Montreal & Toronto
              </span style="color:dodgerblue">
            </h3>   
          </div>
          <div class="col-lg-6 col-sm-12 ml-auto mr-auto gap">
            <img src="img/transplus_warehouse.jpg">
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 col-sm-12 ">                 
            <img
              src="img/transplus_whse3.jpg"
              style="object-fit: cover;"
            >
          </div>
          <div
            class="col-lg-6 col-sm-12 text-center"
            style="margin: auto;"
          >              
            <h3 class="title">
              <span style="color:dodgerblue">
                +32 years</span> <br> of logistics experience
              </span style="color:dodgerblue">
            </h3>
            <span style="font-size: 1.3em;">Servicing independent businesses all the way to large corporations with their warehousing needs.
            </span>
          </div>
        </div>
        <div class="row">          
          <div class="col-md-8 ml-auto mr-auto text-center">
            <br><br>
            <a
              href="/contactuswarehousinganddistribution"
              class="btnBlue"
            > CONTACT US </a>
          </div>                  
        </div>
      </div>
    </div>  

    
    <!-- --><hr class="tpgreen">    

    <div class="section">
      <div class="container">
        <div class="col-md-10 ml-auto mr-auto  text-center">
          <h2 style="font-weight: 700; font-size:2.5rem">
            We currently distribute to<span style="color:dodgerblue"> major retailers </span> which include:</span style="color:dodgerblue">
          </h2><br>                 
        </div>
        <div class="row col-md-10 ml-auto mr-auto  text-center">                      
          <div
            v-for="{ imgSrc, text, fallback } in [
              {
                imgSrc: 'ad/costco.png',
              },
              {
                imgSrc: 'ad/sobeys.png',
              },
              {
                imgSrc: 'ad/gt.jpg',
              },
              {
                imgSrc: 'ad/jc.png',
              },              
              {
                imgSrc: 'ad/amazon1.png',
              },
              {
                imgSrc: 'ad/bestbuy.jpg',
              },
              {
                imgSrc: 'ad/metro.png',
              },
              {
                imgSrc: 'ad/dollarama.png',
              },
              {
                imgSrc: 'ad/walmart.png',
              },
              {
                imgSrc: 'ad/ct.png',
              },
              {
                imgSrc: 'ad/rona.png',
              },
              {
                imgSrc: 'ad/loblaws.png',
              },                              
                
            ]"
            :key="imgSrc"
            class="col-md-3 col-sm-6"
          >
            <div style="padding: 20%; ">
              <div
                style="position: absolute; top: 0; right: 0; bottom: 0; left: 0; background-size: 75%; background-position: center;"
                :style="{ 'background-image': `url(${imgSrc})` }"
              />
            </div>                                
          </div>          
        </div>
      </div>
    </div>

    <!-- --><hr class="tpgreen">

    <!-- We service a wide range of industries. -->
    <div class="section">
      <div
        class="container"
        style="max-width: 800px"
      >
        <div class="row">
          <div class="col-md-12 ml-auto mr-auto  text-center">
            <h2 style="font-weight: 700; font-size:2.5rem">
              <span style="color:dodgerblue">
                Industries </span> we service to include:
              </span style="color:dodgerblue">
            </h2>
          </div>
        </div>

        <div class="row">
          <div
            v-for="{ imgSrc, text, fallback } in [
              {
                imgSrc: 'fas fa-soup fa-6x',
                text: $t('General.FoodBeverage'),
                fallback: 'Food and Beverage',
              },
              {
                imgSrc: 'fas fa-microwave fa-6x',
                text: $t('General.ConsumerGoods'),
                fallback: 'Consumer Goods',
              },
              {
                imgSrc: 'fas fa-signal-alt fa-6x',
                text: $t('General.eCommerce'),
                fallback: 'eCommerce',
              },
              {
                imgSrc: 'fas fa-tools fa-6x',
                text: $t('General.Manufacturing'),
                fallback: 'Manufacturing',
              },              
              {
                imgSrc: 'fas fa-medkit fa-6x',
                text: $t('General.Health'),
                fallback: 'Healthcare',
              },
              {
                imgSrc: 'fas fa-bags-shopping fa-6x',
                text: $t('General.RetailDis'),
                fallback: 'Retail Distribution',
              },
              
            ]"
            :key="imgSrc"
            class="col-6 col-sm-4"
          >
            <div style="position: relative;text-align:center;color:dodgerblue">
              <i
                :class="imgSrc"
                style="color:dodgerblue"
              />
            </div>
            <h4 class="card-title text-center">
              {{ fallback }}
            </h4>
            <!--
            <div class="features-text">               
               <div style="padding-top:20px; text-align: center" v-html="text">
                {{ fallback }}
              </div>
            </div>
            -->
          </div>
        </div>
      </div>
    </div>
 
    <!-- --><hr class="tpgreen">

    <div class="section">
      <div class="container col-md-10">
        <div class="row">
          <div class="col-md-3  ml-auto mr-auto gap">          
            <div style="color:dodgerblue">
              <i class="far fa-scanner-keyboard fa-6x" />
            </div>
            <h4
              class="card-title "
              v-html="$t('Warehouse.WMS')"
            >
              WMS - Warehouse Management System
            </h4>
            <p
              class="card-text "
              style="font-size:14px"
              v-html="$t('Warehouse.WMSdesc')"
            >
              Our cutting-edge WMS ensures complete control over your inventory. Real-time information is provided through web portals and Electronic Data Interchange (EDI). Upon request, we will work with you to integrate and map your transactions into or from our WMS. Both our WMS and TMS are interactively linked for greater efficiency. 
            </p>
          </div>
          <div class="col-md-3  ml-auto mr-auto gap">
            <div style="color:dodgerblue">
              <i class="far fa-file-certificate fa-6x" />
            </div>
            <h4
              class="card-title"
              v-html="$t('Warehouse.AIB')"
            >
              AIB and HACCP Certified
            </h4>
            <p
              class="card-text"
              style="font-size:14px"
              v-html="$t('Warehouse.AIBdesc')"
            >
              Our facilities are AIB and HACCP certified. These globally recognized standards are key requirements that we meet to ensure your products stay safe throughout storage and distribution. From food to consumer products, we are committed to preventing damage and reducing waste.
            </p>              
              
            <p>
              <img
                slot="image"
                :src="imgAIB"
                width="50%"
              >
              <img
                slot="image"
                :src="imgHACCP"
                width="30%"
              >
            </p>
          </div>

          <div class="col-md-3 ml-auto mr-auto gap">          
            <div style="color:dodgerblue">
              <i class="far fa-shield-check fa-6x" />
            </div>
            <h4
              class="card-title"
              v-html="$t('Warehouse.Customs')"
            >
              Customs Bonded Warehouses Approved
            </h4>
            <p
              class="card-text"
              style="font-size:14px"
              v-html="$t('Warehouse.Customsdesc')"
            >
              We offer bonded warehouses, should you require this service for storing your import or export goods.
            </p>
            <p>
              <img
                slot="image"
                :src="imgCBSA"
                style="display: block; width: 40%;"
              >
            </p>        
          </div>
          <div class="col-md-3 ml-auto mr-auto gap">          
            <div style="color:dodgerblue">
              <i class="far fa-tasks fa-6x" />
            </div>
            <h4
              class="card-title"
              v-html="$t('Warehouse.YMS')"
            >
              YMS - Yard Management System
            </h4>
            <p
              class="card-text"
              style="font-size:14px"
              v-html="$t('Warehouse.YMSdesc')"
            >
              Having the right balance of inbound and outbound freight relies on effective yard management. Real-time yard counts and asset activities enable accurate visibility. For seamless management operations, our YMS is integrated with our WMS and TMS.
            </p>
          </div>
        </div>
      </div>
    </div>   

    <!-- --><hr class="tpgreen">

    <div class="section">
      <div class="container col-md-8">
        <div class="ml-auto mr-auto  text-center">
          <h2 style="font-weight: 700; font-size:2.5rem">
            Get what your <span style="color:dodgerblue"> business needs </span> with:</span style="color:dodgerblue">
          </h2><br>                 
        </div>      
        
        <div class="row">
          <div class="col-md-4  ml-auto mr-auto gap">                        
            <h3
              class="card-title"
              style="color:dodgerblue; height:70px;"
            >
              <i class="far fa-check fa-1x" /> Inventory sorting and consolidation
            </h3>
            <p
              class="card-text "
              style="font-size: 1.3em;"
            >
              Full Pallet Pick<br>
              Cross-docking and Transloading<br>
              Full Suite of Container Services<br>
              Deconsolidation<br>
              Consolidation
            </p>
          </div>
          <div class="col-md-4  ml-auto mr-auto gap">              
            <h3
              class="card-title"
              style="color:dodgerblue; height:70px;"
            >
              <i class="far fa-check fa-1x" /> Customization and sub assembly
            </h3>
            <p
              class="card-text"
              style="font-size: 1.3em;"
            >
              Kitting<br>
              Pick and Pack<br>
              Rework and Repair
            </p>                            
          </div>

          <div class="col-md-4 ml-auto mr-auto gap">                        
            <h3
              class="card-title"
              style="color:dodgerblue; height:70px;"
            >
              <i class="far fa-check fa-1x" /> Added value services
            </h3>              
            <p
              class="card-text"
              style="font-size: 1.3em;"
            >
              Full Spectrum Service<br>
              Lot Management<br>
              Inventory Quantity Management<br>
              Blocking and Bracing<br>
              Securing
            </p>      
          </div>
        </div>
      </div>
    </div>  

    <!-- --><hr class="tpgreen">

    <div class="section">
      <div class="container col-md-10">     
        <div class="ml-auto mr-auto  text-center">
          <div class="row">
            <div
              class="col-md-6"
              style="margin: auto;"
            >
              <h2 class="title">
                Let Transplus handle your <br>Warehousing and Distribution needs
              </h2>
              <p
                class="card-text"
                style="font-size: 1.3em;"
              >
                so that you can focus on your core business <br> * space size: Minimum of 5K sq/ft storage required
              </p>  
              
              <div
                class="footer-content"
                style="padding-top:20px;"
              >
                <a
                  href="/contactuswarehousinganddistribution"
                  class="btnBlue"
                > CONTACT US </a>
                <a
                  v-if="isMobile()"
                  href="tel:416-938-1293"
                  class="btnWhite"
                > CALL US</a>  
                <a
                  v-if="!isMobile()"
                  href="tel:416-938-1293"
                  class="btnWhite"
                >CALL 416-938-1293</a>  
              </div>                            
            </div>
            <div class="col-md-6">
              <img
                slot="image"
                src="img/whse_rack.jpg"
              >
            </div>
          </div>        
        </div>    
      </div>
    </div>
  </div>      
</template>

<script scoped>

import FloatingVideoPlayer from './FloatingVideoPlayer.vue'

export default {
  components: {
    FloatingVideoPlayer
  },
  data () {
    return {
      imgWare: "img/transplus_warehouse.jpg",
      imgTrans: "img/bg4.jpg",
      imgFreight: "img/bg3.jpg",
      imgAIB: "img/aib.jpg",
      imgAIB2: "img/aib2.png",
      imgHACCP: "img/haccp.png",      
      imgCBSA: "img/cbsa.jpg", 

    }
  },
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    handleClose() {
      // Handle close event
    }    
  }  
};
</script>

<style scoped>

  ul#menu li {
    display:inline;
    padding-left:10px;
    padding-right:10px;
  }

.page-header-image {
    background-color:blue;
    background-image: url('https://www.transplus.com/img/tp_ad01.jpg');
}

.features-text {
    font-size: 180%;
}
.header {
  position: relative;
  min-height: 100vh;
  padding-top:6vh;
}

.header-content {
  position: absolute;
  bottom: -20px;
  left: 0;
  width:100%;
  padding-bottom:10vh;
}
.btnBlue{
  background-color:dodgerblue;
  text-align:center;
  border-radius: 5px;
  border-style:solid;
  border-color: dodgerblue;  
  color: white;
  font-size: 1.6em;
  width:200px;
  margin:5px;
  transition: width 1s;
  padding: 11px 22px 11px 22px;  
  text-decoration: none;
}
.btnBlue:hover {
  background-color:#58a8f5;

}
.btnWhite{
  background-color:white;
  text-align:center;
  border-radius: 5px;
  color: dodgerblue;
  font-size: 1.6em;
  width:200px;
  margin:5px;
  transition: width 1s;
  padding: 11px 22px 11px 22px;
  text-decoration: none;  
  border-style:solid;
  border-color: white;  
}
.btnWhite:hover {
  background-color:whitesmoke;
  border-style:solid;
  border-color: dodgerblue;  

}

.adlogo {
    height:60px; 
    filter: brightness(0) invert(1);
    back-color: rgb(40, 144, 255)
}

@media (max-width: 768px) {
  .hide {
    display: none;
  }

    ul#menu li {
      display:inline;
      padding-left:5px;
      padding-right:5px;
    }


    .adlogo {
        height:50px; 
        filter: brightness(0) invert(1);
    }    
    .header {
    position: relative;
    min-height: 100vh;
    padding-top:5vh;
    font-size: 75%;
    }

    .header-content {
    position: absolute;
    bottom: 0;
    left: 0;
    width:100%;
    padding-bottom:5vh;
    }
    .footer-content {
      font-size: 10px;
    }    
}
</style>